/** Translate shared storefront UI with the Nuxt locale (including SSR). */
export function useCommonUiTranslation() {
  const { t } = useI18n()
  return (source, params) => t(`commonUi.${source}`, params || {})
}
